module.exports = __webpack_public_path__ + "fonts/Selima.cf73d268.ttf";